import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template: `
    <div class="unauthorized-container">
      <div class="unauthorized-message">
        <h1>Unauthorized Access</h1>
        <p>You are not authorized to access this application.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #f5f5f5;
    }
    .unauthorized-message {
      text-align: center;
      padding: 2rem;
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      max-width: 500px;
    }
    h1 {
      color: #d32f2f;
      margin-bottom: 1rem;
    }
    p {
      color: #616161;
      margin-bottom: 0.5rem;
    }
  `]
})
export class UnauthorizedComponent {
  constructor() {}
}